import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="attendance"
export default class extends Controller {
  static targets = [
    "selectAll",
    "checkbox",
    "selectedCount",
    "bulkActions",
    "form"
  ]

  connect() {
    this.updateUI()
  }

  // Toggle all checkboxes when "Select All" is clicked
  toggleAll() {
    const isChecked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      if (!checkbox.disabled) {
        checkbox.checked = isChecked
      }
    })
    this.updateUI()
  }

  // Update UI when individual checkbox changes
  toggle() {
    this.updateUI()
  }

  // Update selected count and bulk action visibility
  updateUI() {
    const checkedCount = this.getSelectedIds().length
    const totalEnabled = this.checkboxTargets.filter(cb => !cb.disabled).length

    // Update selected count display
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = checkedCount
    }

    // Show/hide bulk actions
    if (this.hasBulkActionsTarget) {
      if (checkedCount > 0) {
        this.bulkActionsTarget.classList.remove("hidden")
      } else {
        this.bulkActionsTarget.classList.add("hidden")
      }
    }

    // Update "Select All" checkbox state
    if (this.hasSelectAllTarget) {
      if (checkedCount === 0) {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = false
      } else if (checkedCount === totalEnabled) {
        this.selectAllTarget.checked = true
        this.selectAllTarget.indeterminate = false
      } else {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = true
      }
    }
  }

  // Get array of selected booking IDs
  getSelectedIds() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  // Submit bulk attendance action
  submitBulk(event) {
    event.preventDefault()
    const action = event.currentTarget.dataset.action.split("#")[1] === "markAttended" ? "checked_in" : "no_show"
    const selectedIds = this.getSelectedIds()

    if (selectedIds.length === 0) return

    // Create form data
    const formData = new FormData()
    formData.append("attendance_status", action)
    selectedIds.forEach(id => {
      formData.append("booking_ids[]", id)
    })

    // Get the form action URL from the form target
    const url = this.formTarget.action

    // Submit via fetch with Turbo
    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
      // Clear checkboxes after successful bulk action
      this.checkboxTargets.forEach(cb => cb.checked = false)
      if (this.hasSelectAllTarget) {
        this.selectAllTarget.checked = false
      }
      this.updateUI()
    })
    .catch(error => {
      console.error("Error submitting bulk attendance:", error)
    })
  }

  markAttended(event) {
    event.currentTarget.dataset.action = "attendance#markAttended"
    this.submitBulk(event)
  }

  markNoShow(event) {
    event.currentTarget.dataset.action = "attendance#markNoShow"
    this.submitBulk(event)
  }
}
